import { EventEmitter } from 'fbemitter'

// eslint-disable-next-line import/no-anonymous-default-export
export default new EventEmitter()
